import { normalizeMarketForFilter } from "../../../CompanyUserInfo/options/marketOptions"

export const TOGGLE_COLLAPSE = "TOGGLE_COLLAPSE"
export const OPEN_INDIVIDUAL_SUBFORM = "OPEN_INDIVIDUAL_SUBFORM"
export const OPEN_COMPANY_SUBFORM = "OPEN_COMPANY_SUBFORM"
export const OPEN_FREELANCERS_SUBFORM = "OPEN_FREELANCERS_SUBFORM"
export const SET_WHOLE_STATE = "SET_WHOLE_STATE"
export const SET_JOB_TITLE = "SET_JOB_TITLE"
export const SET_JOB_TITLE_INPUT = "SET_JOB_TITLE_INPUT"
export const SET_LOCATION = "SET_LOCATION"
export const SET_LOCATION_INPUT = "SET_LOCATION_INPUT"
export const SET_ROLE_TYPE = "SET_ROLE_TYPE"
export const SET_ACTIVITY_TYPE = "SET_ACTIVITY_TYPE"
export const SET_GENDER_TYPE = "SET_GENDER_TYPE"
export const SET_RACE_TYPE = "SET_RACE_TYPE"
export const SET_COMPANY_ROLE_TYPE = "SET_COMPANY_ROLE_TYPE"
export const SET_COMPANY_ACTIVITY_TYPE = "SET_COMPANY_ACTIVITY_TYPE"
export const SET_COMPANY_INDUSTRY_TYPE = "SET_COMPANY_INDUSTRY_TYPE"
export const SET_COMPANY_DEPARTMENT_TYPE = "SET_COMPANY_DEPARTMENT_TYPE"
export const SET_COMPANY_DIVERSE_TYPE = "SET_COMPANY_DIVERSE_TYPE"
export const SET_COMPANY_CLASSIFICATION = "SET_COMPANY_CLASSIFICATION"
export const SET_COMPANY_MARKET = "SET_COMPANY_MARKET"
export const SET_COMPANY_TYPE = "SET_COMPANY_TYPE"
export const SET_COMPANY_CERTIFIED = "SET_COMPANY_CERTIFIED"
export const SET_COMPANY_VERIFICATION_TYPE = "SET_COMPANY_VERIFICATION_TYPE"
export const SET_LEVEL_TYPE = "SET_LEVEL_TYPE"
export const RESET_FORM = "RESET_FORM"
export const SET_SKILL = "SET_SKILL"
export const SET_SKILL_INPUT = "SET_SKILL_INPUT"
export const SET_CATEGORY_TYPE = "SET_CATEGORY_TYPE"
export const SET_FREELANCERS_COUNTRY = "SET_FREELANCERS_COUNTRY"
export const SET_PROFESSION_TYPE = "SET_PROFESSION_TYPE"
export const SET_EXPERIENCE_TYPE = "SET_EXPERIENCE_TYPE"
export const SET_COMPANY_NAME = "SET_COMPANY_NAME"
export const SET_COMPANY_NAME_INPUT = "SET_COMPANY_NAME_INPUT"
export const SET_TITLE = "SET_TITLE"
export const SET_TITLE_INPUT = "SET_TITLE_INPUT"

const initValues = {
  accountType: "individual",
  jobTitle: "",
  jobTitleInput: "",
  location: "",
  locationInput: "",
  skill: "",
  skillInput: "",
  roleType: "",
  activityType: "",
  genderType: "",
  raceType: "",
  professionType: "",
  experienceType: "",
  companyName: "",
  companyNameInput: "",
  title: "",
  titleInput: "",
  companyRoleType: "",
  companyActivityType: "",
  companyIndustryType: "",
  companyDepartmentType: "",
  companyDiverseType: "",
  companyClassification: "",
  companyMarket: "",
  companyType: "",
  companyCertified: "",
  companyVerificationType: "",
  levelType: "",
  categoryType: "",
  freelancersCountry: "",
}
export const initState = {
  isCollapse: false,
  values: initValues,
}

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case TOGGLE_COLLAPSE: {
      return { ...state, isCollapse: !state.isCollapse }
    }
    case OPEN_INDIVIDUAL_SUBFORM: {
      return {
        ...state,
        values: {
          ...state.values,
          accountType: "individual",
          companyName: "",
          companyNameInput: "",
          title: "",
          titleInput: "",
          professionType: "",
          experienceType: "",
          companyIndustryType: "",
          genderType: "",
          companyMarket: "",
        },
      }
    }
    case OPEN_FREELANCERS_SUBFORM: {
      return {
        ...state,
        values: {
          ...state.values,
          accountType: "freelancers",
          jobTitle: "",
          jobTitleInput: "",
          location: "",
          locationInput: "",
          skill: "",
          skillInput: "",
          roleType: "",
          activityType: "",
          genderType: "",
          raceType: "",
          companyRoleType: "",
          companyActivityType: "",
          companyIndustryType: "",
          companyDepartmentType: "",
          companyDiverseType: "",
          companyClassification: "",
          companyMarket: "",
          categoryType: "",
          freelancersCountry: "",
        },
      }
    }
    case OPEN_COMPANY_SUBFORM: {
      return {
        ...state,
        values: {
          ...state.values,
          accountType: "company",
          jobTitle: "",
          jobTitleInput: "",
          location: "",
          locationInput: "",
          skill: "",
          skillInput: "",
          roleType: "",
          activityType: "",
          genderType: "",
          raceType: "",
          companyRoleType: "",
          companyActivityType: "",
          companyIndustryType: "",
          companyDepartmentType: "",
          companyDiverseType: "",
          companyClassification: "",
          companyMarket: "",
        },
      }
    }
    case SET_WHOLE_STATE: {
      const {
        requestResultGroup: {
          account_type,
          job_title,
          location,
          skill,
          describe_me,
          activity,
          gender,
          race,
          describe_company,
          industry,
          department,
          diverse,
          classifications,
          markets,
          solopreneur,
          certified,
          verification_type,
          level_type,
        },
      } = payload
      const values = {}
      if (account_type === "individual") {
        values.accountType = account_type ? account_type : ""
        values.companyName = payload.requestResultGroup.company_name
          ? payload.requestResultGroup.company_name
          : ""
        values.companyNameInput = payload.requestResultGroup.company_name
          ? payload.requestResultGroup.company_name
          : ""
        values.title = payload.requestResultGroup.title
          ? payload.requestResultGroup.title
          : ""
        values.titleInput = payload.requestResultGroup.title
          ? payload.requestResultGroup.title
          : ""
        values.professionType = payload.requestResultGroup.profession
          ? payload.requestResultGroup.profession
          : ""
        values.experienceType = payload.requestResultGroup.experience
          ? payload.requestResultGroup.experience
          : ""
        values.companyIndustryType = industry ? industry : ""
        values.genderType = gender ? gender : ""
        values.companyMarket = normalizeMarketForFilter(markets)
      } else if (account_type === "freelancers") {
        values.accountType = account_type ? account_type : ""
        values.categoryType = payload.requestResultGroup.category
          ? payload.requestResultGroup.category
          : ""
        values.freelancersCountry = payload.requestResultGroup.country
          ? payload.requestResultGroup.country
          : ""
      } else {
        values.accountType = account_type ? account_type : ""
        values.companyType =
          solopreneur !== undefined
            ? solopreneur === "true"
              ? "true"
              : "false"
            : ""
        values.companyRoleType = describe_company ? describe_company : ""
        values.companyActivityType = activity ? activity : ""
        values.companyIndustryType = industry ? industry : ""
        values.companyDepartmentType = department ? department : ""
        values.companyDiverseType = diverse ? diverse : ""
        values.companyClassification = classifications ? classifications : ""
        values.companyMarket = normalizeMarketForFilter(markets)
        values.companyCertified = certified !== undefined ? certified : ""
        values.companyVerificationType = verification_type
          ? verification_type
          : ""
        values.levelType = level_type ? level_type : ""
      }
      return { ...state, values: { ...initValues, ...values } }
    }
    case SET_JOB_TITLE: {
      const { jobTitle } = payload
      return {
        ...state,
        values: { ...state.values, jobTitle, jobTitleInput: jobTitle },
      }
    }
    case SET_JOB_TITLE_INPUT: {
      const { jobTitleInput } = payload
      return {
        ...state,
        values: { ...state.values, jobTitle: "", jobTitleInput },
      }
    }
    case SET_LOCATION: {
      const { location } = payload
      return {
        ...state,
        values: { ...state.values, location, locationInput: location },
      }
    }
    case SET_LOCATION_INPUT: {
      const { locationInput } = payload
      return {
        ...state,
        values: { ...state.values, location: "", locationInput },
      }
    }
    case SET_SKILL: {
      const { skill } = payload
      return {
        ...state,
        values: { ...state.values, skill, skillInput: skill },
      }
    }
    case SET_SKILL_INPUT: {
      const { skillInput } = payload
      return {
        ...state,
        values: { ...state.values, skill: "", skillInput },
      }
    }
    case SET_ROLE_TYPE: {
      const { roleType } = payload
      return {
        ...state,
        values: { ...state.values, roleType, activityType: "" },
      }
    }
    case SET_ACTIVITY_TYPE: {
      const { activityType } = payload
      return { ...state, values: { ...state.values, activityType } }
    }
    case SET_GENDER_TYPE: {
      const { genderType } = payload
      return { ...state, values: { ...state.values, genderType } }
    }
    case SET_RACE_TYPE: {
      const { raceType } = payload
      return { ...state, values: { ...state.values, raceType } }
    }
    case SET_COMPANY_ROLE_TYPE: {
      const { companyRoleType } = payload
      return {
        ...state,
        values: { ...state.values, companyRoleType, companyActivityType: "" },
      }
    }
    case SET_COMPANY_ACTIVITY_TYPE: {
      const { companyActivityType } = payload
      return { ...state, values: { ...state.values, companyActivityType } }
    }
    case SET_COMPANY_INDUSTRY_TYPE: {
      const { companyIndustryType } = payload
      return { ...state, values: { ...state.values, companyIndustryType } }
    }
    case SET_COMPANY_DEPARTMENT_TYPE: {
      const { companyDepartmentType } = payload
      return { ...state, values: { ...state.values, companyDepartmentType } }
    }
    case SET_COMPANY_DIVERSE_TYPE: {
      const { companyDiverseType } = payload
      return { ...state, values: { ...state.values, companyDiverseType } }
    }
    case SET_COMPANY_CLASSIFICATION: {
      const { companyClassification } = payload
      return { ...state, values: { ...state.values, companyClassification } }
    }
    case SET_COMPANY_MARKET: {
      const { companyMarket } = payload
      return {
        ...state,
        values: {
          ...state.values,
          companyMarket: normalizeMarketForFilter(companyMarket),
        },
      }
    }
    case SET_COMPANY_TYPE: {
      const { companyType } = payload
      return { ...state, values: { ...state.values, companyType } }
    }
    case SET_COMPANY_CERTIFIED: {
      const { companyCertified } = payload
      return { ...state, values: { ...state.values, companyCertified } }
    }
    case SET_COMPANY_VERIFICATION_TYPE: {
      const { companyVerificationType } = payload
      return { ...state, values: { ...state.values, companyVerificationType } }
    }
    case SET_LEVEL_TYPE: {
      const { levelType } = payload
      return { ...state, values: { ...state.values, levelType } }
    }
    case RESET_FORM: {
      return {
        ...state,
        values: { ...initValues, accountType: state.values.accountType },
      }
    }
    case SET_CATEGORY_TYPE: {
      const { categoryType } = payload
      return { ...state, values: { ...state.values, categoryType } }
    }
    case SET_FREELANCERS_COUNTRY: {
      const { freelancersCountry } = payload
      return { ...state, values: { ...state.values, freelancersCountry } }
    }
    case SET_PROFESSION_TYPE: {
      const { professionType } = payload
      return { ...state, values: { ...state.values, professionType } }
    }
    case SET_EXPERIENCE_TYPE: {
      const { experienceType } = payload
      return { ...state, values: { ...state.values, experienceType } }
    }
    case SET_COMPANY_NAME: {
      const { companyName } = payload
      return {
        ...state,
        values: { ...state.values, companyName, companyNameInput: companyName },
      }
    }
    case SET_COMPANY_NAME_INPUT: {
      const { companyNameInput } = payload
      return {
        ...state,
        values: { ...state.values, companyName: "", companyNameInput },
      }
    }
    case SET_TITLE: {
      const { title } = payload
      return {
        ...state,
        values: { ...state.values, title, titleInput: title },
      }
    }
    case SET_TITLE_INPUT: {
      const { titleInput } = payload
      return {
        ...state,
        values: { ...state.values, title: "", titleInput },
      }
    }
    default:
      throw new Error("Unknown action")
  }
}
